import { render, staticRenderFns } from "./ReviewConfirmSave.vue?vue&type=template&id=d31bb586&scoped=true"
import script from "./ReviewConfirmSave.vue?vue&type=script&lang=js"
export * from "./ReviewConfirmSave.vue?vue&type=script&lang=js"
import style0 from "./ReviewConfirmSave.vue?vue&type=style&index=0&id=d31bb586&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d31bb586",
  null
  
)

export default component.exports